import { takeLatest, put, call } from "redux-saga/effects";
import * as API from "us.collection.admin/services";
import * as Actions from "us.collection.admin/actions";
import { NonProductionDay } from "us.collection.admin/constants/Actions";
import { $Message, $MessageBox } from "us.common/components";
import { getFormattedRedDays } from "us.collection.admin/functions/NonProductionDays";
import { i18n } from "us.helper";
import dayjs from "dayjs";

const { nonProductionDays_New } = Actions;

const NonProductionDaySagas = {
  calendar: {
    update: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        const data = yield call(API.nonProductionDays.calendar.update, params);
        $MessageBox(
          "success",
          `US.COMMON:MESSAGES.SUCCESSFULLY_UPDATED`,
          "",
          "",
        );
        yield put(nonProductionDays_New.calendar.success(data));
      } catch (error) {
        $MessageBox(
          "error",
          "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.CALENDAR_UPDATE_FAILED",
          "",
          "",
        );
        yield put(nonProductionDays_New.calendar.fail(error as any));
      }
    },
    init: function* (action: any): any {
      try {
        const params = action?.payload?.data ?? {};
        const data = yield call(API.nonProductionDays.calendar.init, params);
        if (nonProductionDays_New.calendar.initSuccess) {
          yield put(nonProductionDays_New.calendar.initSuccess(data));
        }
      } catch (error) {
        if (nonProductionDays_New.calendar.initFail) {
          yield put(nonProductionDays_New.calendar.initFail(error as any));
        }
      }
    },
  },
  ScheduleTimeSlots: {
    get: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        const data = yield call(
          API.nonProductionDays.ScheduleTimeSlots.get,
          params,
        );
        yield put(nonProductionDays_New.ScheduleTimeSlots.success(data));
      } catch (error) {
        yield put(nonProductionDays_New.ScheduleTimeSlots.fail(error as any));
      }
    },
  },
  redDays: {
    get: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        const data = yield call(API.nonProductionDays.redDays.get, params);
        yield put(nonProductionDays_New.redDays.success(data));
      } catch (error) {
        yield put(nonProductionDays_New.redDays.fail(error as any));
      }
    },
    update: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        $Message.loading(i18n.t("COMMON.UPDATING") as string, 0);
        const { data, status } = yield call(
          API.nonProductionDays.redDays.update,
          params,
        );
        if (status == 201) {
          if (nonProductionDays_New.redDays.updateSuccess) {
            yield put(nonProductionDays_New.redDays.updateSuccess(params));
          }
          const year = dayjs(params?.dateRange[0]).year() ?? dayjs().year();
          const data = yield call(API.nonProductionDays.redDays.get, {
            year: `${year}`,
          });
          yield put(nonProductionDays_New.redDays.success(data));
          $Message.destroy();
          $MessageBox(
            "success",
            "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.CALENDAR_UPDATED_SUCCESSFULLY",
            "",
            "",
          );
        } else {
          if (nonProductionDays_New.redDays.updateFail) {
            yield put(nonProductionDays_New.redDays.updateFail(params));
          }
          $Message.destroy();
          if (status === 409) {
            $MessageBox(
              "error",
              "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.DUPLICATE_ENTRY_ERROR_MESSAGE",
              "",
              "",
            );
          } else {
            $MessageBox(
              "error",
              "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.CALENDAR_UPDATE_FAILED",
              "",
              "",
            );
          }
        }
      } catch (error) {
        if (nonProductionDays_New.redDays.updateFail) {
          yield put(nonProductionDays_New.redDays.updateFail(error as any));
        }
        $Message.destroy();
        $MessageBox(
          "error",
          "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.CALENDAR_UPDATE_FAILED",
          "",
          "",
        );
      }
    },
    delete: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        $Message.loading(i18n.t("COMMON.DELETING") as string, 0);
        const { data, status } = yield call(
          API.nonProductionDays.redDays.delete,
          params,
        );
        if (status == 200) {
          const year = dayjs(params?.startDate).year() ?? dayjs().year();
          const data = yield call(API.nonProductionDays.redDays.get, {
            year: `${year}`,
          });
          yield put(nonProductionDays_New.redDays.success(data));
          $Message.destroy();
          $MessageBox(
            "success",
            "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.CALENDAR_UPDATED_SUCCESSFULLY",
            "",
            "",
          );
        } else {
          $Message.destroy();
          $MessageBox(
            "error",
            "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.CALENDAR_UPDATE_FAILED",
            "",
            "",
          );
        }
      } catch (error) {
        $Message.destroy();
        $MessageBox(
          "error",
          "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.CALENDAR_UPDATE_FAILED",
          "",
          "",
        );
      }
    },
  },
  weekendConfigurations: {
    get: function* (action: any): any {
      try {
        const data = yield call(
          API.nonProductionDays.weekendConfigurations.get,
          {},
        );
        yield put(nonProductionDays_New.weekendConfigurations.success(data));
      } catch (error) {
        yield put(
          nonProductionDays_New.weekendConfigurations.fail(error as any),
        );
      }
    },
    update: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        $Message.loading(i18n.t("COMMON.UPDATING") as string, 0);
        const { data, status } = yield call(
          API.nonProductionDays.weekendConfigurations.update,
          params,
        );
        if (status == 201) {
          yield put(
            nonProductionDays_New.weekendConfigurationsUpdate.success(data),
          );
          const redDays = yield call(
            API.nonProductionDays.weekendConfigurations.get,
            {},
          );
          yield put(
            nonProductionDays_New.weekendConfigurations.success(redDays),
          );
          $Message.destroy();
          $MessageBox(
            "success",
            "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.WEEKEND_CONFIG_UPDATED_SUCCESSFULLY",
            "",
            "",
          );
        } else {
          yield put(
            nonProductionDays_New.weekendConfigurationsUpdate.fail(data),
          );
          $Message.destroy();
          $MessageBox(
            "error",
            "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.WEEKEND_CONFIG_UPDATE_FAILED",
            "",
            "",
          );
        }
      } catch (error) {
        yield put(
          nonProductionDays_New.weekendConfigurationsUpdate.fail(error as any),
        );
        $Message.destroy();
        $MessageBox(
          "error",
          "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.WEEKEND_CONFIG_UPDATE_FAILED",
          "",
          "",
        );
      }
    },
  },
  copyCalendarData: {
    get: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        const { data, status } = yield call(
          API.nonProductionDays.copyCalendarData.get,
          params,
        );
        if (status === 200) {
          yield put(nonProductionDays_New.previousCalendarData.success(data));
        } else if (status === 401) {
          yield put(nonProductionDays_New.previousCalendarData.fail(data));
          $MessageBox(
            "error",
            "US.COMMON:UNAUTHORIZED.YOU_DO_NOT_HAVE_PERMISSION_TO_PERFORM_THIS_ACTION",
            "",
            "",
          );
        } else if (status === 404) {
          yield put(nonProductionDays_New.previousCalendarData.fail(data));
          $MessageBox(
            "error",
            "US.COLLECTION.ADMIN:COPY_CALENDAR.PREVIOUS_CALENDAR_DATA_NOT_FOUND",
            "",
            "",
          );
        } else {
          yield put(nonProductionDays_New.previousCalendarData.fail(data));
          $MessageBox(
            "error",
            "US.COLLECTION.ADMIN:COPY_CALENDAR.PREVIOUS_CALENDAR_DATA_FETCH_FAILED",
            "",
            "",
          );
        }
      } catch (error) {
        yield put(
          nonProductionDays_New.previousCalendarData.fail(error as any),
        );
        $MessageBox(
          "error",
          "US.COLLECTION.ADMIN:COPY_CALENDAR.PREVIOUS_CALENDAR_DATA_FETCH_FAILED",
          "",
          "",
        );
      }
    },
    save: function* (action: any): any {
      const payloadData = action?.payload?.data ?? {};
      const params = payloadData?.request ?? payloadData;
      const navigate = payloadData?.navigate;
      try {
        const { data, status } = yield call(
          API.nonProductionDays.copyCalendarData.post,
          params,
        );
        if (status === 201) {
          const year = dayjs(params[0]?.startDate).year() ?? dayjs().year();
          const data = yield call(API.nonProductionDays.redDays.get, {
            year: `${year}`,
          });
          yield put(nonProductionDays_New.copiedCalendarData.success(data));
          $MessageBox(
            "success",
            "US.COLLECTION.ADMIN:COPY_CALENDAR.CALENDAR_COPIED_SUCCESSFULLY",
            "",
            "",
          );
          if (typeof navigate === "function") {
            navigate(`/non-production-days?year=${year}`);
          }
        } else {
          yield put(nonProductionDays_New.copiedCalendarData.fail(data));
          $MessageBox(
            "error",
            "US.COLLECTION.ADMIN:COPY_CALENDAR.CALENDAR_COPY_FAILED",
            "",
            "",
          );
        }
      } catch (error) {
        yield put(nonProductionDays_New.copiedCalendarData.fail(error as any));
        $MessageBox(
          "error",
          "US.COLLECTION.ADMIN:COPY_CALENDAR.CALENDAR_COPY_FAILED",
          "",
          "",
        );
      }
    },
  },
};

export default [
  takeLatest(
    NonProductionDay.GET_SCHEDULES_TIME_SLOTS,
    NonProductionDaySagas.ScheduleTimeSlots.get,
  ),
  takeLatest(
    NonProductionDay.GET_NON_PRODUCTION_DAYS,
    NonProductionDaySagas.redDays.get,
  ),
  takeLatest(
    NonProductionDay.SAVE_NON_PRODUCTION_DAYS,
    NonProductionDaySagas.redDays.update,
  ),
  takeLatest(
    NonProductionDay.SAVE_CALENDAR,
    NonProductionDaySagas.calendar.update,
  ),
  takeLatest(
    NonProductionDay.INIT_NON_PRODUCTION,
    NonProductionDaySagas.calendar.init,
  ),
  takeLatest(
    NonProductionDay.DELETE_NON_PRODUCTION_DAYS,
    NonProductionDaySagas.redDays.delete,
  ),
  takeLatest(
    NonProductionDay.GET_WEEKEND_CONFIGURATIONS,
    NonProductionDaySagas.weekendConfigurations.get,
  ),
  takeLatest(
    NonProductionDay.SAVE_WEEKEND_CONFIGURATIONS,
    NonProductionDaySagas.weekendConfigurations.update,
  ),
  takeLatest(
    NonProductionDay.GET_PREVIOUS_CALENDAR_DATA,
    NonProductionDaySagas.copyCalendarData.get,
  ),
  takeLatest(
    NonProductionDay.SAVE_COPIED_CALENDAR_DATA,
    NonProductionDaySagas.copyCalendarData.save,
  ),
];
